export default __webpack_public_path__ + "slices/main/assets/public/media/masthead/cf-thumb@2x.7f210971fbd436f3dc098548eea68736.png";